import { render } from "./WalletTabs.vue?vue&type=template&id=f10fd22a&scoped=true"
import script from "./WalletTabs.vue?vue&type=script&lang=js"
export * from "./WalletTabs.vue?vue&type=script&lang=js"

import "./WalletTabs.vue?vue&type=style&index=0&id=f10fd22a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f10fd22a"]])

export default __exports__